import TEvaluate from './evaluate.vue'
export default TEvaluate


// WEBPACK FOOTER //
// ./src/components/evaluate/index.js